import { TotalType } from "@qivia/ui/src/designSystem/components/Charts/CardChart";
import {
  dateFormatterDayShortMonthYear,
  dateFormatterMonthYear,
} from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { EmptyChart } from "./emptyChart";
import { extractMultipleLineChartData } from "./lib";
import { MultipleLineChartDS } from "@qivia/ui/src/designSystem/components/Charts/MultipleLineChart";
import { GetTransactionsAmountsPerPeriodType } from "../../transactions/transactionsAPI";
import "../../../../i18n/i18n";

export const PricePerLiterPerFuelMultipleLineChart = (props: {
  totalType: TotalType;
  data: GetTransactionsAmountsPerPeriodType;
}) => {
  const { t } = useTranslation();

  const pricePerLiterPerFuelData = extractMultipleLineChartData({
    transactions: props.data,
    totalType: props.totalType,
    dataPath: "averagePricePerLiterPerFuel",
    formatter:
      props.totalType === "month"
        ? dateFormatterDayShortMonthYear
        : dateFormatterMonthYear,
  });

  return (
    <>
      {!pricePerLiterPerFuelData.length ? (
        <EmptyChart />
      ) : (
        <MultipleLineChartDS
          transactions={pricePerLiterPerFuelData}
          unit={t("dashboard.charts.title.pricePerLiter.unit")}
        />
      )}
    </>
  );
};
